module.exports = __webpack_public_path__ + "img/tempus-pro.f0ce2eaf.png";